import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import _ from "lodash";
import { Button, Col, Dropdown, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { CgUndo } from "react-icons/cg";
import removeHTML from "./RemoveHTML";
import AndamentoProrrogacaoOs from "./AndamentoProrrogacaoOs";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import TelaProximaAtividadeProrrogacao from "./TelaProximaAtividadeProrrogacao";
import DateTime from "../../../../components/Formatters/DateTime";
// import FileDownloader from "../../../../components/UI/Button/FileDownloader";
import useCancelarAtividade from "../hooks/useCancelarAtividade";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import OsContext from "../../../../context/OsContext";

const ProrrogacaoOsDetalhes = ({ data }) => {
  const [mostrarAndamento, setMostrarAndamento] = useState(false);
  const { request: requestProrrog, data: dataProrrog } = useApiClient();
  const [dados, setDados] = useState({});
  const [proximasAtividades, setProximasAtividades] = useState([]);
  const [showCancelarConfirm, setShowCancelarConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });
  // , nuOrdemServico, sqAcaoFiscal, inscricaoestadual, cnpj, dados.fgEfis
  const prorrogacaoContexto = useContext(OsContext);
  const { location, nuOrdemServico, sqAcaoFiscal, inscricaoestadual, cnpj } = prorrogacaoContexto;
  const { pathname } = location;
  const caminho = pathname === "/app/os/consultarOs/consulta";

  const SolicitarMostrarAndamento = () => {
    if (!mostrarAndamento) {
      setMostrarAndamento(true);
    } else {
      setMostrarAndamento(false);
    }
  };

  useEffect(() => {
    const params = {
      sqPedidoProrrogacao: data.sqPedidoProrrogacao,
      sqAcaoFiscal: data.dadosOs.acaoFiscal,
    };
    requestProrrog(apiRoutes.fiscalizacao.prorrogacaoos.ultimaatividadeprorrogacao, params);
  }, [data, requestProrrog]);

  useEffect(() => {
    if (dataProrrog) {
      setDados(dataProrrog.result[0]);
    }
  }, [dataProrrog, setDados]);

  const {
    request: proximasAtividadesRequest,
    data: proximasAtividadesData,
    errors: proximasAtividadesErrors,
  } = useApiClient();

  useEffect(() => {
    if (
      dados?.sequencialRoteiro &&
      dados?.sequencialRoteiro > 0 &&
      dados?.sequencialUltimaAtividade &&
      dados?.sequencialUltimaAtividade > 0
    ) {
      const parametros = {
        sequencialRoteiro: dados?.sequencialRoteiro,
        sequencialAtividade: dados?.sequencialUltimaAtividade,
        sequencialAcaoFiscal: data?.dadosOs.acaoFiscal,
        sequencialPedidoProrrogacao: dados?.sqPedidoProrrogacao,
      };
      proximasAtividadesRequest(apiRoutes.fiscalizacao.ordemservico.proximasAtividades, parametros);
    }
  }, [proximasAtividadesRequest, data, dados]);

  useEffect(() => {
    if (!proximasAtividadesData && !proximasAtividadesErrors) return;

    if (proximasAtividadesData) {
      setProximasAtividades(proximasAtividadesData.result);
    }

    if (proximasAtividadesErrors) toast.error(proximasAtividadesErrors.message);
  }, [proximasAtividadesData, proximasAtividadesErrors]);

  const [proximaAtividadeSelecionada, setProximaAtividadeSelecionada] = useState({});

  const handleRealizarAtividade = (_atividade) => {
    setProximaAtividadeSelecionada(_atividade);
  };

  const { cancelarAtividade, cancelarErrors, cancelarIsLoading } = useCancelarAtividade({ dados });

  const prorrogacao = { nuOrdemServico, sqAcaoFiscal, inscricaoestadual, cnpj, fgEfis: dados.fgEfis };

  return (
    <>
      <EfisModal
        title="Atenção!"
        show={showCancelarConfirm.show}
        body={showCancelarConfirm.body}
        closeHandler={() => setShowCancelarConfirm({ show: false })}
        primaryLabel="Sim"
        secondaryLabel="Não"
        confirmationHandler={() => {
          cancelarAtividade();
        }}
      />
      <div style={{ width: "100%" }}>
        <FormAlert errors={cancelarErrors} isLoading={cancelarIsLoading} dismissible />

        <Row style={{ margin: 20, textAlign: "left" }}>
          <Col xs={12}>
            <strong>Justificativa do Pedido de Prorrogação: </strong>
            <br />
            <span>{removeHTML(dados?.txJustificativa)}</span>
          </Col>
        </Row>
        {dados.stProrroga === "N" && (
          <Row style={{ margin: 20, textAlign: "left" }}>
            <Col xs={12}>
              <strong>Justificativa do gestor para não prorrogação dos prazos da OS: </strong>
              <br />
              <span>{removeHTML(dados?.txProrrogacao)} </span>
            </Col>
          </Row>
        )}
        <Row sm="12">
          <Col>
            <Row className="mt-4" style={{ margin: 20, textAlign: "left" }}>
              <Col>
                <p>
                  <strong>Última Atividade Realizada</strong>
                  <br />
                  {dados?.nomeUltimaAtividade === null ? (
                    "-"
                  ) : (
                    <>
                      <span className="text-primary"> {dados?.nomeUltimaAtividade} </span>
                      {/*
                      {dados?.docUltimaAtividade !== null && (
                        <FileDownloader
                          binario={dados?.docUltimaAtividade}
                          tooltip="Visualizar Documento"
                          className="ml-2"
                        />
                      )}
                      */}
                      {!caminho && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Cancelar</Tooltip>}>
                          <CgUndo
                            className="text-danger pa-0 p-0 btn btn-lg btn-bg-transparent"
                            onClick={() =>
                              setShowCancelarConfirm({
                                show: true,
                                body: "Confirma o Cancelamento da Atividade?",
                              })
                            }
                          />
                        </OverlayTrigger>
                      )}
                    </>
                  )}
                  <br />( {dados?.codigoUserUltimaAtividade} - {dados?.nomeUserUltimaAtividade} -
                  <DateTime value={dados?.dataInclusaoUltimaAtividade} /> )
                </p>

                {dados?.situacaoUltimoAndamento !== "A" && !caminho && (
                  <Dropdown className="mt-4 mb-4">
                    <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                      Realizar Atividade
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {proximasAtividades?.length > 0 ? (
                        proximasAtividades.map((_atividade) => {
                          const itemMenu = (
                            <Dropdown.Item onClick={() => handleRealizarAtividade(_atividade)}>
                              {_atividade.nomeAtividade}
                            </Dropdown.Item>
                          );
                          return itemMenu;
                        })
                      ) : (
                        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">
                          Nenhuma atividade para o usuário logado
                        </span>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}

                <TelaProximaAtividadeProrrogacao
                  dadosOs={data.dadosOs}
                  data={dados}
                  atividade={
                    proximaAtividadeSelecionada.sequencialAtividade
                      ? proximaAtividadeSelecionada
                      : _.find(
                          proximasAtividades,
                          (atividade) => atividade.sequencialAtividade === dados?.sqAtividadeUltimoAndamento,
                        )
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ marginLeft: -5, marginTop: 0, marginBottom: 20, textAlign: "left" }}>
          <Col sm="12" className="form-inline">
            <Button className="mr-0 btn btn-primary btn-md btn-user mx-4" onClick={() => SolicitarMostrarAndamento()}>
              Andamento Prorrogação
            </Button>
          </Col>
        </Row>
        <Row hidden={!mostrarAndamento} style={{ marginLeft: -15, marginTop: 0, marginBottom: 20 }}>
          <Col>
            <div>
              <Col sm="12" className="form-inline justify-content-end">
                <AndamentoProrrogacaoOs
                  numOs={data.dadosOs.sequencial}
                  numProrrogacaoOs={dados?.sqPedidoProrrogacao}
                  prorrogacao={prorrogacao}
                />
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ProrrogacaoOsDetalhes;
